import { Injectable } from '@angular/core';
import { StatsRepoService } from '@client/app/services/api/stats-repo/stats-repo.service';
import { StatisticsParamsService } from '@client/app/pages/statistics/services/statistics-params.service';
import { SITE_ANALYTICS_PAGE_DEFINITIONS } from '@client/app/feature-modules/site-analytics/definitions/site-analytics-page-definitions';
import type {
    SiteAnalyticsDataRequest,
    SiteAnalyticsDataResult,
} from '@client/app/feature-modules/site-analytics/types/site-analytics-page-scaffold.type';
import { StatisticsEventsRepoService } from '@monsido/modules/statistics/pages/content/events/services/statistics-events/statistics-events.repo.service';

@Injectable({
    providedIn: 'root',
})
export class SiteAnalyticsPageDataService {
    constructor (
        private readonly statsRepoService: StatsRepoService,
        private readonly statisticsParamsService: StatisticsParamsService,
        private readonly statisticsEventsRepoService: StatisticsEventsRepoService,
    ) {}

    async loadData (request: SiteAnalyticsDataRequest): Promise<SiteAnalyticsDataResult> {
        const definition = SITE_ANALYTICS_PAGE_DEFINITIONS[request.dataSource];

        return definition.loadData(request, {
            statsRepoService: this.statsRepoService,
            statisticsParamsService: this.statisticsParamsService,
            statisticsEventsRepoService: this.statisticsEventsRepoService,
        });
    }
}
